<template>
  <VModal ref="contactUnsubscribeDialog" @close="$emit('close')">
    <template #default="modalProps">
      <div
        class="rounded shadow-xs bg-gray-100 overflow-hidden mx-auto lg:max-w-lg sm:w-full flex flex-col"
      >
        <div class="flex-none px-4 sm:px-6 py-5 border-b bg-white">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <h1 class="text-sm">Unsubscribe Contact</h1>
            </div>
            <button
              type="button"
              class="rounded-md text-gray-400 hover:text-gray-800 focus:outline-none"
              @click="modalProps.close"
            >
              <!-- Heroicon name: outline/x -->
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
        <div class="flex-1 p-4 sm:p-6 bg-white">
          <BaseVeeForm :action="handleUnsubscribeContact" @success="handleContactUnsubscribed">
            <!-- formProps
              isIdle, isPending, isResolved, isRejected, invalid
              errors, submit
            -->
            <template #default="formProps">
              <div>
                <BaseFormTextFieldWithValidator
                  v-bind="contactIdFieldProps"
                  :value="data.contact_id"
                  :disabled="formProps.isPending"
                />
                <div class="space-y-8">
                  <BaseFormTextareaFieldWithValidator
                    v-model="data.reason"
                    v-bind="reasonFieldProps"
                    :disabled="formProps.isPending"
                  />
                  <BaseButton primary> Unsubscribe </BaseButton>
                </div>
              </div>
            </template>
          </BaseVeeForm>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import { accountUnsubscribedContactsClient } from '@/api/clients';

export default {
  name: 'ContactUnsubscribeDialog',
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: {
        contact_id: this.contact.id,
        reason: '',
      },
    };
  },
  computed: {
    contactIdFieldProps() {
      return {
        validator: {
          name: 'contact',
          vid: 'contact_id',
          rules: { required: true },
        },
        field: {
          id: 'contact_id',
          inputType: 'hidden',
        },
      };
    },
    reasonFieldProps() {
      return {
        validator: {
          name: 'reason',
          vid: 'reason',
          rules: {
            required: false,
          },
        },
        field: {
          id: 'reason',
          label: 'Unsubscribe reason',
        },
      };
    },
  },
  methods: {
    handleUnsubscribeContact() {
      return accountUnsubscribedContactsClient.store(this.contact.accountId, this.data);
    },
    handleContactUnsubscribed() {
      this.$emit('contact:unsubscribed');
      this.$refs.contactUnsubscribeDialog.close();
    },
  },
};
</script>
